module.exports = __webpack_public_path__ + "static/media/job-post-5.6abb3601.svg";